<template>
  <v-main class="grey lighten-4">
    <v-container>
      <v-card class="rounded-xl elevation-4" max-width="1200">
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-pencil</v-icon>
          Editar Serviço
        </v-card-title>

        <v-divider></v-divider>

        <!-- Formulário -->
        <v-form v-model="valid" ref="form" class="pa-6">
          <!-- Nome do Serviço -->
          <v-text-field
            v-model="nomeEspecialidade"
            label="Nome do Serviço"
            disabled
            outlined
            dense
            prepend-icon="mdi-rename-box"
          ></v-text-field>

          <!-- Local da Recepcionista -->
          <v-autocomplete
            v-model="idLocalEscolhido"
            :items="listaLocais"
            item-value="idLocal"
            item-text="nomeLocal"
            label="Local da Recepcionista *"
            :rules="[(v) => !!v || 'Local obrigatório']"
            outlined
            dense
            prepend-icon="mdi-map-marker"
          ></v-autocomplete>

          <!-- Seção Condicional: Configurações Médicas -->
          <template v-if="atendimentoMedico == 1">
            <v-subheader class="pl-0 mt-2 text-subtitle-1 primary--text">
              <v-icon left color="primary">mdi-stethoscope</v-icon>
              Configurações Médicas
            </v-subheader>

            <!-- Locais de Atendimento -->
            <v-autocomplete
              v-model="idLocaisMedico"
              :items="listaLocais"
              item-value="idLocal"
              item-text="nomeLocal"
              label="Locais de Atendimento *"
              :rules="[(v) => v && v.length > 0 || 'Selecione pelo menos um local']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-hospital-marker"
              @input="alterarLocalAtendimento()"
            ></v-autocomplete>

            <!-- Médicos -->
            <v-autocomplete
              v-model="listaMedicosServico"
              :items="listaMedicos"
              item-value="idMedico"
              :item-text="item => `${item.nome} - ${item.login}`"
              label="Médicos *"
              :rules="[listaMedicosServico.length > 0 || listaTecnicosServico.length > 0 || 'Selecione pelo menos um prestador']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-doctor"
              @input="alterarListaMedicos()"
            ></v-autocomplete>

            <!-- Técnicos -->
            <v-autocomplete
              v-model="listaTecnicosServico"
              :items="listaTecnicos"
              item-value="idMedico"
              :item-text="item => `${item.nome} - ${item.login}`"
              label="Técnicos *"
              :rules="[listaMedicosServico.length > 0 || listaTecnicosServico.length > 0 || 'Selecione pelo menos um prestador']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-account-cog"
              @input="alterarListaTecnicos()"
            ></v-autocomplete>
          </template>

          <!-- Dias da Semana -->
          <v-autocomplete
            v-model="diasDaSemana"
            :items="listaDiasDaSemana"
            item-value="diaSemana"
            item-text="dia"
            label="Dias da Semana *"
            :rules="[(v) => v && v.length > 0 || 'Selecione pelo menos um dia']"
            outlined
            dense
            multiple
            chips
            small-chips
            prepend-icon="mdi-calendar"
            @input="alterarDiasDaSemana()"
          ></v-autocomplete>

          <!-- Opções -->
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="exbibirAtendente"
                label="Exibir serviço para a Atendente?"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="peso"
                :false-value="0"
                :true-value="1"
                label="Prioridade para a recepcionista?"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="checkbox"
                :rules="[(v) => !!v || 'Você deve concordar para continuar']"
                label="Você concorda com as alterações?"
                color="primary"
                required
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- Mensagens de Feedback -->
          <v-alert
            v-model="erroEditar"
            type="error"
            dismissible
            class="mt-4"
          >
            Erro ao editar serviço!
          </v-alert>

          <v-alert
            v-model="erroDiasIguais"
            type="error"
            dismissible
            class="mt-4"
          >
            Dias da semana já cadastrados para este Serviço
          </v-alert>

          <v-alert
            v-model="erroLociasIguais"
            type="error"
            dismissible
            class="mt-4"
          >
            Locais de atendimentos já cadastrados para esse serviço
          </v-alert>

          <v-alert
            v-model="sucessoEditar"
            type="success"
            dismissible
            class="mt-4"
          >
            Serviço atualizado com sucesso!
          </v-alert>

          <!-- Ações -->
          <v-card-actions class="px-0 mt-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              large
              rounded
              @click="alterarServico"
              :class="{ red: !valid, green: valid }"
              :disabled="!valid"
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="grey darken-1"
              large
              rounded
              outlined
              to="/servicosUnidade"
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
// O script permanece EXATAMENTE o mesmo que o original
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'editarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      item: '',
      erroEditar: false,
      diasDaSemana: [],
      servico: {
        idExameEspecialidade: '',
        nomeEspecialidade: '',
        atendimentoMedico: ''
      },
      listaMedicos: [],
      listaMedicosServico: [],
      listaMedicosServicoInicial: [],
      idMedicos: [],
      listaTecnicos: [],
      listaTecnicosServico: [],
      listaTecnicosServicoInicial: [],
      atendimentoMedico: '',
      erroDiasIguais: false,
      erroLociasIguais: false,
      alterouDiasDaSemana: false,
      alterouLocaisAtendimento: false,
      alterouListaMedicos: false,
      alterouListaTecnicos: false,
      diasDaSemanaInicial: [],
      sucessoEditar: false,
      listaLocais: [],
      diaSemana: '',
      idServico: '',
      isEditing: true,
      nomeEspecialidade: '',
      user: null,
      listaDiasDaSemana: [{
        dia: 'Segunda-feira',
        diaSemana: 1
      }, {
        dia: 'Terça-feira',
        diaSemana: 2
      },
      {
        dia: 'Quarta-feira',
        diaSemana: 3
      }, {
        dia: 'Quinta-feira',
        diaSemana: 4
      },
      {
        dia: 'Sexta-feira',
        diaSemana: 5
      }, {
        dia: 'Sábado',
        diaSemana: 6
      }, {
        dia: 'Domingo',
        diaSemana: 0
      }
      ],
      idLocalEscolhido: '',
      idLocaisMedico: [],
      idLocaisMedicoInicial: [],
      valid: false,
      checkbox: false,
      exbibirAtendente: '',
      peso: 0,
      nomeRules: [
        (v) => v && v.length > 2 || 'nome deve ter mais de 5 caracteres'
      ]
    }
  },
  mounted () {
    if (!this.$route.params.item) {
      this.$router.push({
        name: 'servicosUnidade'
      })
      return
    }

    this.user = this.$store.getters.usuario
    this.inicializarPorRota()
    this.erroEditar = false
    this.sucessoEditar = false
    this.retornarLocais()
    this.retornarLocalMedico(this.idServico)
    if (this.atendimentoMedico == 1) {
      this.carregarPrestadores()
    }
  },
  methods: {
    inicializarPorRota () {
      const item = this.$route.params.item
      const diasDaSemana = this.$route.params.diasDaSemana

      this.atendimentoMedico = item.atendimentoMedico
      this.diasDaSemana = Array.isArray(diasDaSemana) ? diasDaSemana : []
      this.diasDaSemanaInicial = Array.isArray(diasDaSemana) ? diasDaSemana : []
      this.idServico = item.idServico
      this.peso = item.peso
      this.exbibirAtendente = item.exibirAtendente
      this.diaSemana = this.item = item.diaSemana
      this.nomeEspecialidade = item.nomeEspecialidade
      this.idLocalEscolhido = item.idLocal
    },

    carregarPrestadores () {
      return Promise.all([
        this.retornarTodosMedicos(),
        this.retornarPossiveisTecnicos()
      ]).then(() => {
        this.retornarMedicoTecnico()
      })
    },

    retornarPossiveisTecnicos () {
      return administradorUnidadeService.administradorUnidade
        .retornarPossiveisTecnicos()
        .then(rsp => {
          this.listaTecnicos = this.normalizarPrestadores(rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarTodosMedicos () {
      return administradorUnidadeService.administradorUnidade
        .retornarTodosMedicos()
        .then(rsp => {
          this.listaMedicos = this.normalizarPrestadores(rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarMedicoTecnico () {
      administradorUnidadeService.administradorUnidade
        .retornarMedicoTecnico(this.idServico)
        .then(rsp => {
          const medicos = rsp.data
            .filter(element => element.tecnico === 0)
            .map(element => element.idMedico)
          const tecnicos = rsp.data
            .filter(element => element.tecnico === 1)
            .map(element => element.idMedico)

          // Atualizar listas de médicos e técnicos
          this.listaMedicosServico = medicos
          this.listaMedicosServicoInicial = [...medicos]
          this.listaTecnicosServico = tecnicos
          this.listaTecnicosServicoInicial = [...tecnicos]
        })
        .catch(err => {
          // Tratar erro
          console.error('Erro ao retornar médicos e técnicos:', err)
        })
    },

    normalizarPrestadores (lista) {
      if (!Array.isArray(lista)) return []
      const porId = new Map()
      lista.forEach(item => {
        if (item && item.idMedico != null && !porId.has(item.idMedico)) {
          porId.set(item.idMedico, item)
        }
      })
      return Array.from(porId.values())
    },

    mostrarDiferencas () {
      // Converter listas em Sets para busca rápida
      const medicosSet = new Set(this.listaMedicos.map(medico => medico.idMedico))
      const tecnicosSet = new Set(this.listaTecnicos.map(tecnico => tecnico.idMedico))

      // Filtrar médicos e técnicos que não estão na lista geral
      const difMed = this.listaMedicosServico.filter(idMedico => !medicosSet.has(idMedico))
      const difTec = this.listaTecnicosServico.filter(idTecnico => !tecnicosSet.has(idTecnico))

      return { difMed, difTec }
    },

    alterarDiasDaSemana () {
      this.alterouDiasDaSemana = true
    },

    alterarLocalAtendimento () {
      this.alterouLocaisAtendimento = true
    },

    alterarListaMedicos () {
      this.alterouListaMedicos = true
    },
    alterarListaTecnicos () {
      this.alterouListaTecnicos = true
    },

    alterarServico () {
      if (this.$refs.form.validate()) {
        let diasDaSemanaAux = []
        let idLocaisMedicoAux = []
        let idMedicos = []
        let idTecnicos = []
        let diasDaSemanaSemNull = []
        const idUnidade = (this.user && this.user.idUnidade) || this.$route.params.item.idUnidade
        this.erroEditar = false
        this.sucessoEditar = false
        this.erroDiasIguais = false // n terá mais
        this.erroLociasIguais = false // n tera mais..

        if (this.alterouLocaisAtendimento) {
          idLocaisMedicoAux = this.verificarIdLocaisMedico()
          // console.log('idLocaisMedicoAux', idLocaisMedicoAux);
        }

        if (this.alterouListaMedicos) {
          idMedicos = this.verificarListaMedicos()
        }

        if (this.alterouListaTecnicos) {
          idTecnicos = this.verificarListaTecnicos()
        }
        const idMedicoTecnico = [...idMedicos, ...idTecnicos]

        if (this.diasDaSemana.length == 0 && this.diasDaSemanaInicial.length > 0) {
          for (let index = 0; index < this.diasDaSemanaInicial.length; index++) {
            const element = this.diasDaSemanaInicial[index]
            diasDaSemanaAux[index] = {
              diaSemana: element,
              status: 0
            }
          }
        }
        // talvez nunca caia aqui..
        else if (this.diasDaSemanaInicial.length == 0 && this.diasDaSemana.length > 0) {
          console.log('segundo if')
          for (let index = 0; index < this.diasDaSemana.length; index++) {
            const element = this.diasDaSemana[index]
            diasDaSemanaAux[index] = {
              diaSemana: element,
              status: 1
            }
          }
          // console.log(servicosAux);
          // return
        } else {
          let diasDaSemanaInicial = this.diasDaSemanaInicial
          for (let index = 0; index < this.diasDaSemana.length; index++) {
            const element = this.diasDaSemana[index]
            diasDaSemanaAux[index] = {
              diaSemana: element,
              status: null
            }
          }

          diasDaSemanaAux.forEach(function (elementEscolhido, indexAux) {
            let estava = false
            let index = 0
            for (let index = 0; index < diasDaSemanaInicial.length; index++) {
              const element = diasDaSemanaInicial[index]
              if (element == elementEscolhido.diaSemana) {
                estava = true
              }
            }
            if (!estava) {
              diasDaSemanaAux[indexAux].status = 1
            }
          })

          diasDaSemanaInicial.forEach(function (elementInicial, indexInicial) {
            let removeu = false
            let diaSemana = 0
            for (let index = 0; index < diasDaSemanaAux.length; index++) {
              const element = diasDaSemanaAux[index]
              if (element.diaSemana == elementInicial) {
                removeu = true
                // diaSemana = element.diaSemana
              }
            }
            if (!removeu) {
              diaSemana = elementInicial
              diasDaSemanaAux.push({
                diaSemana: diaSemana,
                status: 0
              })
            }
          })
          console.log(diasDaSemanaAux)

          for (let i = 0; i < diasDaSemanaAux.length; i++) {
            if (diasDaSemanaAux[i].status != null) {
              diasDaSemanaSemNull.push(diasDaSemanaAux[i])
              // console.log(diasDaSemanaAux);
            }
          }
          diasDaSemanaAux = diasDaSemanaSemNull
          console.log('dias da semana sem null') // n precisa mais verificar se é null
          console.log(diasDaSemanaAux)
        }
        administradorUnidadeService.administradorUnidade
          .alterarServico(idUnidade, this.idServico, this.idLocalEscolhido, idMedicoTecnico, idLocaisMedicoAux,
            diasDaSemanaAux, this.peso, this.exbibirAtendente, idMedicos, idTecnicos)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }

            if (rsp.data == true) {
              setTimeout(() => this.$router.push({
                path: '/servicosUnidade'
              }), 2000)
              this.sucessoEditar = true
              this.clear()
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    // novo tecnico

    verificarListaTecnicos () {
      const listaTecnicosAux = new Map()
      const listaTecnicosSemNull = []

      // Preencher listaTecnicosAux com base em listaTecnicosServicoInicial
      this.listaTecnicosServicoInicial.forEach(element => {
        const idTecnico = element && element.idMedico != null ? element.idMedico : element
        if (idTecnico == null) return
        listaTecnicosAux.set(idTecnico, { idMedico: idTecnico, status: 0 })
      })

      // Atualizar listaTecnicosAux com base em listaTecnicosServico
      this.listaTecnicosServico.forEach(idTecnico => {
        if (idTecnico == null) return
        if (listaTecnicosAux.has(idTecnico)) {
          // Técnico já existe na lista inicial, portanto atualiza o status para 1
          listaTecnicosAux.get(idTecnico).status = 1
        } else {
          // Técnico é novo, adiciona à lista
          listaTecnicosAux.set(idTecnico, { idMedico: idTecnico, status: 1 })
        }
      })

      // Verificar técnicos removidos e adicioná-los à listaTecnicosAux
      this.listaTecnicosServicoInicial.forEach(elementInicial => {
        const idTecnico = elementInicial && elementInicial.idMedico != null ? elementInicial.idMedico : elementInicial
        if (idTecnico == null) return
        if (!listaTecnicosAux.has(idTecnico)) {
          listaTecnicosAux.set(idTecnico, { idMedico: idTecnico, status: 0 })
        }
      })

      // Filtrar técnicos com status definido
      listaTecnicosAux.forEach(value => {
        if (value.status !== null) {
          listaTecnicosSemNull.push(value)
        }
      })

      return listaTecnicosSemNull
    },

    // novo medico

    verificarListaMedicos () {
      const listaMedicosAux = new Map()
      const listaMedicosSemNull = []

      // Preencher listaMedicosAux com base em listaMedicosServicoInicial
      this.listaMedicosServicoInicial.forEach(element => {
        const idMedico = element && element.idMedico != null ? element.idMedico : element
        if (idMedico == null) return
        listaMedicosAux.set(idMedico, { idMedico: idMedico, status: 0 })
      })

      // Atualizar listaMedicosAux com base em listaMedicosServico
      this.listaMedicosServico.forEach(idMedico => {
        if (idMedico == null) return
        if (listaMedicosAux.has(idMedico)) {
          // Médico já existe na lista inicial, portanto atualiza o status para 1
          listaMedicosAux.get(idMedico).status = 1
        } else {
          // Médico é novo, adiciona à lista
          listaMedicosAux.set(idMedico, { idMedico: idMedico, status: 1 })
        }
      })

      // Verificar médicos removidos e adicioná-los à listaMedicosAux
      this.listaMedicosServicoInicial.forEach(elementInicial => {
        const idMedico = elementInicial && elementInicial.idMedico != null ? elementInicial.idMedico : elementInicial
        if (idMedico == null) return
        if (!listaMedicosAux.has(idMedico)) {
          listaMedicosAux.set(idMedico, { idMedico: idMedico, status: 0 })
        }
      })

      // Filtrar médicos com status definido
      listaMedicosAux.forEach(value => {
        if (value.status !== null) {
          listaMedicosSemNull.push(value)
        }
      })

      return listaMedicosSemNull
    },

    verificarIdLocaisMedico () {
      let idLocaisMedicoAux = []
      let idLocaisMedicoAuxNull = []
      // console.log('primeiro if', this.idLocaisMedico)
      if (this.idLocaisMedico.length == 0 && this.idLocaisMedicoInicial.length > 0) { // verificar se pode cair aqui
        for (let index = 0; index < this.idLocaisMedicoInicial.length; index++) {
          const element = this.idLocaisMedicoInicial[index]
          idLocaisMedicoAux[index] = {
            idLocal: element,
            status: 0
          } // 0 removeu
        }
      } else if (this.idLocaisMedicoInicial.length == 0 && this.idLocaisMedico.length > 0) { // verificar se ppode cair aqui
        for (let index = 0; index < this.idLocaisMedico.length; index++) {
          const element = this.idLocaisMedico[index]
          idLocaisMedicoAux[index] = {
            idLocal: element,
            status: 1
          } // 1 adicionou
        }
      } else {
        let idLocaisMedicoInicial = this.idLocaisMedicoInicial
        for (let index = 0; index < this.idLocaisMedico.length; index++) {
          const element = this.idLocaisMedico[index]
          idLocaisMedicoAux[index] = {
            idLocal: element,
            status: null
          }
        }

        idLocaisMedicoAux.forEach(function (elementEscolhido, indexAux) {
          let estava = false
          for (let index = 0; index < idLocaisMedicoInicial.length; index++) {
            const element = idLocaisMedicoInicial[index]
            if (element == elementEscolhido.idLocal) {
              estava = true
            }
          }
          if (!estava) {
            idLocaisMedicoAux[indexAux].status = 1
          }
        })

        idLocaisMedicoInicial.forEach(function (elementInicial, indexInicial) {
          let removeu = false
          let idLocal = 0
          for (let index = 0; index < idLocaisMedicoAux.length; index++) {
            const element = idLocaisMedicoAux[index]
            if (element.idLocal == elementInicial) {
              removeu = true
              // idLocal = element.idLocal
            }
          }
          if (!removeu) {
            idLocal = elementInicial
            idLocaisMedicoAux.push({
              idLocal: idLocal,
              status: 0
            })
          }
        })

        // console.log('------ ----- ', idLocaisMedicoAux)

        for (let i = 0; i < idLocaisMedicoAux.length; i++) {
          if (idLocaisMedicoAux[i].status != null) {
            idLocaisMedicoAuxNull.push(idLocaisMedicoAux[i])
            // console.log(idLocaisMedicoAux);
          }
        }
        idLocaisMedicoAux = idLocaisMedicoAuxNull
        return idLocaisMedicoAux
      }
      return idLocaisMedicoAux
    },

    retornarLocais () {
      administradorUnidadeService.administradorUnidade
        .retornarLocais()
        .then(rsp => {
          this.listaLocais = this.normalizarLocais(rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarLocalMedico (idServico) {
      administradorUnidadeService.administradorUnidade
        .retornarLocalMedico(idServico)
        .then(rsp => {
          const locais = Array.isArray(rsp.data)
            ? rsp.data.map(item => item.idLocal)
            : []
          this.idLocaisMedico = locais
          this.idLocaisMedicoInicial = [...locais]
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    normalizarLocais (lista) {
      if (!Array.isArray(lista)) return []
      const porId = new Map()
      lista.forEach(item => {
        if (item && item.idLocal != null && !porId.has(item.idLocal)) {
          porId.set(item.idLocal, item)
        }
      })
      return Array.from(porId.values())
    },
    clear () {
      this.$refs.form.reset()
    }

  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
  overflow: hidden;
}

.v-btn {
  text-transform: none;
  letter-spacing: normal;
  min-width: 120px;
}

.v-subheader {
  font-size: 1rem;
  height: 48px;
}

@media (max-width: 600px) {
  .v-card__title {
    font-size: 1.25rem;
    padding: 16px;
  }

  .v-btn {
    width: 100%;
    margin-bottom: 8px;
  }

  .v-card__actions {
    flex-direction: column;
  }
}
</style>
